import {
  AppstoreAddOutlined,
  EnvironmentOutlined,
  UnorderedListOutlined,
} from "@ant-design/icons";
import { Tooltip } from "antd";
import CountinueOnMobileApp from "apps/Common/CountiueOnMobileApp";
import { hanldleSetRealStateViewingMode } from "apps/RealState/ListItems/ClientStates";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store/Reducers";

const ViewingModes = () => {
  const { viewingModes } = useSelector((state: RootState) => state.realState);
  const dispatch = useDispatch();
  return (
    <>
      <span
        className="hover:cursor-pointer !flex gap-1 !p-2 border border-gray-300 !rounded-md   transition"
        onClick={() => {
          dispatch(hanldleSetRealStateViewingMode({ viewingMode: "cart" }));
        }}
      >
        <AppstoreAddOutlined
          className={`!text-xl hover:cursor-pointer ${
            viewingModes === "cart" ? "!text-black" : "!text-gray-300"
          } `}
        />
      </span>

      <span
        className="hover:cursor-pointer !flex gap-1 !p-2 border border-gray-300 !rounded-md   transition"
        onClick={() => {
          dispatch(hanldleSetRealStateViewingMode({ viewingMode: "list" }));
        }}
      >
        <UnorderedListOutlined
          className={`!text-xl hover:cursor-pointer ${
            viewingModes === "list" ? "!text-black" : "!text-gray-300"
          } `}
        />
      </span>

        <span
          className="hover:cursor-pointer !flex gap-1 !p-2 border border-gray-300 !rounded-md   transition"
          onClick={() => {
            dispatch(hanldleSetRealStateViewingMode({ viewingMode: "map" }));
          }}
        >
          <EnvironmentOutlined
            className={`!text-xl hover:cursor-pointer ${
              viewingModes === "map" ? "!text-black" : "!text-gray-300"
            } `}
          />
        </span>
{
  viewingModes==="map"&&
      <CountinueOnMobileApp isShowChildren={true} isShowDesc={false}>
        <></>
      </CountinueOnMobileApp>
}
    </>
  );
};

export default ViewingModes;
